<template>
  <div class="lt">
    <div class="lt-bottom" v-if="defaultdata && defaultdata.length">
      <div
        class="lt-bt-item"
        v-for="(item, index) in defaultdata.slice(0, 9)"
        :key="index"
      >
        <div class="bg">
          <div
            class="lt-item-title no-select ellipsis"
            style="width: 100px"
            :title="item.value1"
          >
            {{ item.value1 }}
          </div>
          <div class="lt-item-content no-select">
            <div class="item-num" v-if="item.value2">{{ item.value2 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope105",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope105-【组件】图文-9组数据1-完成",
      defaultdata: [
        { value1: "数据一", value2: "000" },
        { value1: "数据二", value2: "000" },
        { value1: "数据三", value2: "000" },
        { value1: "数据四", value2: "000" },
        { value1: "数据五", value2: "000" },
        { value1: "数据六", value2: "000" },
        { value1: "数据七", value2: "000" },
        { value1: "数据八", value2: "000" },
        { value1: "数据九", value2: "000" },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      iscontact: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.slice(0, 9);
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
  },
  mounted() {
    this.setData()
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Benmo-Ziyu";
  src: url("@/assets/fonts/Benmo-Ziyu.woff2");
}

.lt {
  width: 435px;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
  overflow: hidden;
  // pointer-events: auto;
  cursor: pointer;
}

.lt-bottom {
  height: 240px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.lt-bt-item {
  margin-top: -20px;
  width: 145px;
  height: 120px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lt-bt-item:nth-child(3n + 1) {
  margin-left: 0;
}

.lt-bt-item:nth-child(n + 4) {
  margin-top: -50px;
}

.bg {
  width: 127px;
  height: 101px;
  background: url("../../assets/temimg13/tem_lt-bg1.png") no-repeat;
  background-size: 100% 100%;
}

.lt-bottom .lt-bt-item:nth-of-type(2n) {
  .bg {
    background: url("../../assets/temimg13/tem_lt-bg2.png") no-repeat !important;
    background-size: 100% 100% !important;
  }

  .item-num {
    color: #ffb600 !important;
  }
}

.bt-icon {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 36px;
  top: 20px;
}

.lt-item-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #afc2df;
  line-height: 20px;
  height: 20px;
  width: 127px;
  position: relative;
  top: 45px;
  left: 16px;
  z-index: 10;
}

.lt-item-content {
  display: flex;
  margin-top: 40px;
  justify-content: center;
  align-items: center;
}

.item-num {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #7cc0ff;
}

// 禁止选中
.no-select {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
  user-select: none;
  /* Standard syntax */
}
</style>
